import {
  isValidPeriod,
  isTomorrowOrLaterDate,
  isFutureDate,
} from "../date-utils/date-utils";

export const isSalesOrderUpdateability = (serviceWorksheet) => {
  if (serviceWorksheet.status === "DRAFT") {
    return true;
  } else if (serviceWorksheet.status === "ALLOCATED") {
    return isTomorrowOrLaterDate(serviceWorksheet.date.date1Time);
  } else {
    return false;
  }
};

export const checkServiceWorksheetUpdateability = (
  originalServiceWorksheet,
  serviceWorksheet,
) => {
  const newStatus = calculatedStatus(serviceWorksheet);
  if (originalServiceWorksheet.status === "DRAFT") {
    return checkServiceDraftWorksheetUpdateability(serviceWorksheet, newStatus);
  } else if (originalServiceWorksheet.status === "ALLOCATED") {
    return checkServiceAllocatedWorksheetUpdateability(
      originalServiceWorksheet,
      serviceWorksheet,
      newStatus,
    );
  } else {
    return {
      error: true,
      key: "FAILED_NOT_UPDATEABILITY_SERVICE_WORKSHEET",
    };
  }
};

export const isServiceWorksheetDeleteability = (originalServiceWorksheet) => {
  if (originalServiceWorksheet.status === "DRAFT") {
    return true;
  } else if (originalServiceWorksheet.status === "ALLOCATED") {
    return isTomorrowOrLaterDate(originalServiceWorksheet?.date?.date1Time);
  } else {
    return false;
  }
};

export const calculatedStatus = (serviceWorksheet) => {
  if (
    stringIsNullOrEmpty(serviceWorksheet?.template?.id) ||
    stringIsNullOrEmpty(serviceWorksheet?.primaryWorker?.id) ||
    stringIsNullOrEmpty(serviceWorksheet?.date?.type) ||
    dateIsNull(serviceWorksheet?.date?.date1Time) ||
    (serviceWorksheet?.date?.type === "PERIOD" &&
      dateIsNull(serviceWorksheet?.date?.date2Time))
  ) {
    return "DRAFT";
  } else {
    return "ALLOCATED";
  }
};

const checkServiceDraftWorksheetUpdateability = (
  serviceWorksheet,
  newStatus,
) => {
  if (!(newStatus === "DRAFT" || newStatus === "ALLOCATED")) {
    return {
      error: true,
      key: "FAILED_UPDATE_TO_NEW_STATUS",
    };
  }

  if (!dateIsNull(serviceWorksheet?.date?.date1Time)) {
    if (!isFutureDate(serviceWorksheet?.date?.date1Time)) {
      return {
        error: true,
        key: "FAILED_UPDATE_NEW_DATE_IS_NOT_FUTURE_DATE",
      };
    }
    if (
      serviceWorksheet?.date?.type === "PERIOD" &&
      !isValidPeriod(
        serviceWorksheet?.date?.date1Time,
        serviceWorksheet?.date?.date2Time,
      )
    ) {
      return {
        error: true,
        key: "FAILED_UPDATE_NEW_DATE_IS_NOT_VALID_PERIOD",
      };
    }
  }
  return {
    error: false,
  };
};

const checkServiceAllocatedWorksheetUpdateability = (
  originalServiceWorksheet,
  serviceWorksheet,
  newStatus,
) => {
  if (!(newStatus === "DRAFT" || newStatus === "ALLOCATED")) {
    return {
      error: true,
      key: "FAILED_UPDATE_TO_NEW_STATUS",
    };
  }
  if (!isTomorrowOrLaterDate(originalServiceWorksheet?.date?.date1Time)) {
    return {
      error: true,
      key: "FAILED_UPDATE_BECAUSE_ORIGINAL_SERVICE_WORKSHEET_NOT_TODAY_OR_LATER",
    };
  }
  if (
    !dateIsNull(serviceWorksheet?.date?.date1Time) &&
    !isFutureDate(serviceWorksheet?.date?.date1Time)
  ) {
    return {
      error: true,
      key: "FAILED_UPDATE_BECAUSE_UPDATED_SERVICE_WORKSHEET_NOT_NULL_OR_FEATUER",
    };
  }
  if (
    serviceWorksheet?.date?.type === "PERIOD" &&
    !isValidPeriod(
      serviceWorksheet?.date?.date1Time,
      serviceWorksheet?.date?.date2Time,
    )
  ) {
    return {
      error: true,
      key: "FAILED_UPDATE_NEW_DATE_IS_NOT_VALID_PERIOD",
    };
  }
  return {
    error: false,
  };
};

const dateIsNull = (date) => {
  return date === null || isNaN(date);
};

const stringIsNullOrEmpty = (text) => {
  return text === null || text === undefined;
};
